import type * as React from 'react';

import type { Integration, IntegrationContentSource } from '@gitbook/api-client';
import { Image, sizes } from '@gitbook/react-uikit';

import { getImageResizedURL } from '../../utils';
import { IntegrationIcon } from './IntegrationIcon';

/**
 * Icon for an integration's content source.
 */
export function IntegrationContentSourceIcon(props: {
    integration: Integration;
    contentSource: IntegrationContentSource;
    size?: number;
    className?: string;
}): React.ReactElement {
    const { integration, contentSource, className, size = sizes.ICON_400 } = props;

    if (!contentSource.icon) {
        return <IntegrationIcon integration={integration} className={className} size={size} />;
    }

    return (
        <Image
            source={{ uri: getImageResizedURL(contentSource.icon, { width: size }) }}
            style={[
                {
                    width: size,
                    height: size,
                    borderRadius: size / 8,
                },
            ]}
        />
    );
}
